// src/pages/AutomatisationsPage.jsx
import React, { useState, useEffect } from "react";
import {
  BiEnvelope,
  BiSend,
  BiRefresh,
  BiCheckCircle,
  BiErrorCircle,
  BiTime,
  BiPhone,
  BiMessageDetail,
} from "react-icons/bi";
import {
  FaBell,
  FaCalendarAlt,
  FaExclamationCircle,
  FaPlus,
  FaChartPie,
  FaSms,
  FaEnvelope,
  FaCheckCircle,
  FaTimesCircle,
  FaHourglassHalf,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Importer le service
import reminderService from "../../services/reminder.service";

export default function AutomatisationsPage() {
  const [activeTab, setActiveTab] = useState("rappels");
  const [selectedListType, setSelectedListType] = useState(7);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({});

  // États pour les données
  const [summary, setSummary] = useState(null);
  // const [smsStats, setSmsStats] = useState(null);
  const [reminders, setReminders] = useState([]);
  const [selectedReminderType, setSelectedReminderType] = useState(7);
  const [statusFilter, setStatusFilter] = useState("");

  // États pour les modals
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);
  // const [showSmsTracking, setShowSmsTracking] = useState(false);
  // const [smsDetails, setSmsDetails] = useState(null);

  const tabs = [
    // { id: "tout", label: "Tout" },
    { id: "rappels", label: "Rappels" },
    // { id: "notifications", label: "Notifications de rendez-vous" },
  ];

  const notifications = [
    {
      id: 1,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Nouveau rendez-vous",
      description: "Contactez les clients lorsque leur rendez-vous a été pris.",
      active: true,
    },
    {
      id: 2,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Rendez-vous reprogrammé",
      description:
        "Automatiquement envoyé aux clients lorsque l'heure de leur rendez-vous est modifiée.",
      active: true,
    },
    {
      id: 3,
      icon: <FaCalendarAlt className="w-6 h-6" />,
      title: "Rendez-vous annulé",
      description:
        "Automatiquement envoyé aux clients lorsque leur rendez-vous est annulé.",
      active: true,
    },
    {
      id: 4,
      icon: <FaExclamationCircle className="w-6 h-6" />,
      title: "Rendez-vous manqué",
      description:
        "Automatiquement envoyé aux clients quand leur rendez-vous est manqué.",
      active: true,
    },
  ];

  const rappels = [
    {
      id: 7,
      title: "Rappel J-7",
      description: "Notifie les clients 7 jours avant leur rendez-vous.",
      type: 7,
    },
    {
      id: 3,
      title: "Rappel J-3",
      description: "Notifie les clients 3 jours avant leur rendez-vous.",
      type: 3,
    },
    {
      id: 1,
      title: "Rappel J-1",
      description: "Notifie les clients la veille de leur rendez-vous.",
      type: 1,
    },
  ];

  useEffect(() => {
    loadDashboardData();
  }, []);

  // Recharger quand le type de rappel change
  useEffect(() => {
    if (activeTab === "rappels") {
      loadRemindersByType(selectedReminderType);
    }
  }, [selectedReminderType, activeTab]);

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      const [summaryRes] = await Promise.all([
        //smsStatsRes
        reminderService.getSummary(),
        // reminderService.getSmsStatistics(),
      ]);

      setSummary(summaryRes.data.data);
      // setSmsStats(smsStatsRes.data.data);

      toast.success("Données chargées avec succès");
    } catch (error) {
      toast.error("Erreur lors du chargement des données");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const loadRemindersByType = async (days, status = null) => {
    setLoading(true);
    try {
      const response = await reminderService.getReminders(days, status);
      setReminders(response.data.data || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des rappels");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateReminders = async (days) => {
    setActionLoading((prev) => ({ ...prev, [`generate-${days}`]: true }));
    try {
      const response = await reminderService.generateReminders(days);
      toast.success(response.data.message);
      await Promise.all([
        loadDashboardData(),
        loadRemindersByType(selectedReminderType, statusFilter || null),
      ]);
    } catch (error) {
      toast.error(
        error.response?.data?.error || "Erreur lors de la génération",
      );
    } finally {
      setActionLoading((prev) => ({ ...prev, [`generate-${days}`]: false }));
    }
  };

  const handleSendReminders = async (days, type = "email") => {
    setActionLoading((prev) => ({ ...prev, [`send-${type}-${days}`]: true }));
    try {
      let response;
      if (type === "email") {
        response = await reminderService.sendReminders(days);
      }
      // else {
      //   response = await reminderService.sendSmsReminders(days);
      // }

      toast.success(response.data.message);

      // Afficher les détails dans une notification
      const { success, failed } = response.data.data;
      if (failed > 0) {
        toast.warning(`${failed} envois ont échoué. Vérifiez les détails.`);
      }

      await Promise.all([
        loadDashboardData(),
        loadRemindersByType(selectedReminderType, statusFilter || null),
      ]);
    } catch (error) {
      toast.error(
        error.response?.data?.error || `Erreur lors de l'envoi des ${type}`,
      );
    } finally {
      setActionLoading((prev) => ({
        ...prev,
        [`send-${type}-${days}`]: false,
      }));
    }
  };

  // const handleTrackSms = async (messageSid) => {
  //   try {
  //     const response = await reminderService.getSmsStatus(messageSid);
  //     setSmsDetails(response.data.data);
  //     setShowSmsTracking(true);
  //   } catch (error) {
  //     toast.error("Erreur lors du tracking SMS");
  //   }
  // };

  const handleRefresh = () => {
    loadDashboardData();
    loadRemindersByType(selectedReminderType, statusFilter || null);
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="w-full min-h-screen bg-white p-8">
        <div className="max-w-6xl mx-auto">
          {/* Header avec résumé et bouton refresh */}
          <div className="mb-8 flex justify-between items-start">
            <div>
              <h1 className="text-3xl font-bold text-black mb-2">
                Automatisations
              </h1>
              <p className="text-gray-600">
                Consultez et gérez tous les messages automatiques envoyés à vos
                clients.
              </p>
            </div>
            <button
              onClick={handleRefresh}
              disabled={loading}
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
            >
              <BiRefresh
                className={`text-lg ${loading ? "animate-spin" : ""}`}
              />
              Actualiser
            </button>
          </div>

          {/* Résumé des rappels */}
          {summary && (
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-blue-100 text-sm">Total rappels</p>
                    <p className="text-2xl font-bold">{summary.total}</p>
                  </div>
                  <FaBell className="text-3xl opacity-50" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 text-white rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-yellow-100 text-sm">En attente</p>
                    <p className="text-2xl font-bold">{summary.pending}</p>
                  </div>
                  <FaHourglassHalf className="text-3xl opacity-50" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-green-100 text-sm">Envoyés</p>
                    <p className="text-2xl font-bold">{summary.sent}</p>
                  </div>
                  <FaCheckCircle className="text-3xl opacity-50" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-red-500 to-red-600 text-white rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-red-100 text-sm">Échoués</p>
                    <p className="text-2xl font-bold">{summary.failed}</p>
                  </div>
                  <FaTimesCircle className="text-3xl opacity-50" />
                </div>
              </div>

              <div className="bg-gradient-to-br from-purple-500 to-purple-600 text-white rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-purple-100 text-sm">Taux de succès</p>
                    <p className="text-2xl font-bold">
                      {summary.total > 0
                        ? Math.round((summary.sent / summary.total) * 100)
                        : 0}
                      %
                    </p>
                  </div>
                  <FaChartPie className="text-3xl opacity-50" />
                </div>
              </div>
            </div>
          )}

          {/* Tabs */}
          <div className="flex gap-3 mb-8 overflow-x-auto pb-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 font-medium whitespace-nowrap transition-colors rounded ${
                  activeTab === tab.id
                    ? "bg-black text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Content - Rappels */}
          {activeTab === "rappels" && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">
                Rappels automatiques
              </h2>

              {/* Cartes des rappels J-7, J-3, J-1 */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {[7, 3, 1].map((days) => {
                  const reminder = rappels.find((r) => r.type === days);
                  const countByType =
                    summary?.byType?.[
                      days === 7
                        ? "SEVEN_DAYS"
                        : days === 3
                          ? "THREE_DAYS"
                          : "ONE_DAY"
                    ] || 0;

                  return (
                    <div
                      key={days}
                      className={`border rounded-lg p-6 hover:shadow-md transition-shadow cursor-pointer ${
                        selectedReminderType === days
                          ? "border-secondary-500 ring-2 ring-secondary-500 ring-opacity-20"
                          : "border-secondary-200"
                      }`}
                      onClick={() => setSelectedReminderType(days)}
                    >
                      <div className="flex items-start justify-between mb-4">
                        <div className="p-2 bg-gray-100 rounded-lg">
                          <FaCalendarAlt className="text-secondary-500" />
                        </div>
                        <span className="text-sm font-medium text-gray-500">
                          {countByType} rappels
                        </span>
                      </div>
                      <h3 className="font-semibold text-black mb-2">
                        {reminder?.title || `Rappel J-${days}`}
                      </h3>
                      <p className="text-sm text-gray-600 mb-4">
                        {reminder?.description ||
                          `Notifie les clients ${days === 7 ? "une semaine" : days === 3 ? "3 jours" : "la veille"} avant leur rendez-vous.`}
                      </p>

                      {/* Actions */}
                      <div className="flex flex-col gap-2 mt-4">
                        <div className="flex gap-2">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleGenerateReminders(days);
                            }}
                            disabled={actionLoading[`generate-${days}`]}
                            className="flex-1 px-3 py-2 bg-secondary-500 text-white text-sm rounded hover:bg-secondary-800 transition-colors disabled:opacity-50 flex items-center justify-center gap-1"
                          >
                            <FaPlus className="text-xs" />
                            {actionLoading[`generate-${days}`]
                              ? "Génération..."
                              : "Générer"}
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedReminderType(days);
                            }}
                            className="px-3 py-2 bg-gray-100 text-gray-700 text-sm rounded hover:bg-gray-200 transition-colors"
                          >
                            Voir
                          </button>
                        </div>

                        <div className="flex gap-2">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSendReminders(days, "email");
                            }}
                            disabled={actionLoading[`send-email-${days}`]}
                            className="flex-1 px-3 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-1"
                          >
                            <BiEnvelope />
                            {actionLoading[`send-email-${days}`]
                              ? "..."
                              : "Email"}
                          </button>
                          {/* <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSendReminders(days, "sms");
                            }}
                            disabled={actionLoading[`send-sms-${days}`]}
                            className="flex-1 px-3 py-2 bg-green-600 text-white text-sm rounded hover:bg-green-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-1"
                          >
                            <FaSms />
                            {actionLoading[`send-sms-${days}`] ? "..." : "SMS"}
                          </button> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Filtres et tableau des rappels */}
              <div className="mt-8">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">
                    Liste des rappels J-{selectedReminderType}
                  </h3>
                  <select
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      loadRemindersByType(
                        selectedReminderType,
                        e.target.value || null,
                      );
                    }}
                    className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
                  >
                    <option value="">Tous les statuts</option>
                    <option value="PENDING">En attente</option>
                    <option value="SENT">Envoyés</option>
                    <option value="FAILED">Échoués</option>
                  </select>
                </div>

                {/* Tableau des rappels */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Code RDV
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Client
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Date RDV
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Statut
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Contact
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {loading ? (
                        <tr>
                          <td
                            colSpan="6"
                            className="px-4 py-8 text-center text-gray-500"
                          >
                            Chargement...
                          </td>
                        </tr>
                      ) : reminders.length === 0 ? (
                        <tr>
                          <td
                            colSpan="6"
                            className="px-4 py-8 text-center text-gray-500"
                          >
                            Aucun rappel trouvé
                          </td>
                        </tr>
                      ) : (
                        reminders.map((reminder) => (
                          <tr key={reminder.id} className="hover:bg-gray-50">
                            <td className="px-4 py-3 text-sm">
                              {reminder.appointmentCode}
                            </td>
                            <td className="px-4 py-3 text-sm font-medium">
                              {reminder.clientName}
                            </td>
                            <td className="px-4 py-3 text-sm">
                              {new Date(
                                reminder.appointmentDate,
                              ).toLocaleDateString()}
                            </td>
                            <td className="px-4 py-3">
                              <span
                                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium
                                ${reminder.status === "SENT" ? "bg-green-100 text-green-800" : ""}
                                ${reminder.status === "PENDING" ? "bg-yellow-100 text-yellow-800" : ""}
                                ${reminder.status === "FAILED" ? "bg-red-100 text-red-800" : ""}
                              `}
                              >
                                {reminder.status}
                              </span>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex items-center gap-2">
                                <BiEnvelope className="text-gray-400" />
                                <FaSms className="text-gray-400" />
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <button
                                onClick={() => {
                                  setSelectedReminder(reminder);
                                  setShowDetailsModal(true);
                                }}
                                className="text-sm text-blue-600 hover:text-blue-800"
                              >
                                Détails
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Statistiques SMS */}
              {/* {smsStats && (
                <div className="mt-8 p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold mb-3 flex items-center gap-2">
                    <FaSms className="text-gray-600" />
                    Statistiques SMS
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                    <div>
                      <p className="text-xs text-gray-500">Total</p>
                      <p className="text-lg font-semibold">
                        {smsStats.overview.total}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Envoyés</p>
                      <p className="text-lg font-semibold text-green-600">
                        {smsStats.overview.sent}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Délivrés</p>
                      <p className="text-lg font-semibold text-blue-600">
                        {smsStats.overview.delivered}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Échoués</p>
                      <p className="text-lg font-semibold text-red-600">
                        {smsStats.overview.failed}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">En attente</p>
                      <p className="text-lg font-semibold text-yellow-600">
                        {smsStats.overview.pending}
                      </p>
                    </div>
                  </div>
                </div>
              )} */}
            </div>
          )}
        </div>
      </div>

      {/* Modal de détails */}
      {showDetailsModal && selectedReminder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-xl font-bold">Détails du rappel</h3>
                <button
                  onClick={() => setShowDetailsModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>

              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Code RDV</p>
                    <p className="font-medium">
                      {selectedReminder.appointmentCode}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Client</p>
                    <p className="font-medium">{selectedReminder.clientName}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Email</p>
                    <p className="font-medium">
                      {selectedReminder.clientEmail}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Téléphone</p>
                    <p className="font-medium">
                      {selectedReminder.clientPhone}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Date du rendez-vous</p>
                    <p className="font-medium">
                      {new Date(
                        selectedReminder.appointmentDate,
                      ).toLocaleString()}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Total</p>
                    <p className="font-medium">
                      {selectedReminder.totalAmount} FCFA
                    </p>
                  </div>
                </div>

                <div>
                  <p className="text-sm text-gray-500 mb-2">Services</p>
                  <div className="bg-gray-50 rounded-lg p-3">
                    {selectedReminder.services?.map((service, idx) => (
                      <div key={idx} className="flex justify-between text-sm">
                        <span>{service.name}</span>
                        <span>x{service.quantity}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
